(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __moduleCache = /* @__PURE__ */ new WeakMap;
  var __toCommonJS = (from) => {
    var entry = __moduleCache.get(from), desc;
    if (entry)
      return entry;
    entry = __defProp({}, "__esModule", { value: true });
    if (from && typeof from === "object" || typeof from === "function")
      __getOwnPropNames(from).map((key) => !__hasOwnProp.call(entry, key) && __defProp(entry, key, {
        get: () => from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
      }));
    __moduleCache.set(from, entry);
    return entry;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, {
        get: all[name],
        enumerable: true,
        configurable: true,
        set: (newValue) => all[name] = () => newValue
      });
  };

  // js/scripts.ts
  var exports_scripts = {};
  __export(exports_scripts, {
    default: () => scripts_default
  });

  // ../lyquix/js/lib/scripts/core.ts
  var vars = {};
  var cfg = {};

  // js/custom/scripts/regions.ts
  var regions = (() => {
    const init = (customCfg) => {
      if (vars.regions?.init)
        return;
      vars.regions = {
        init: false,
        searchQuery: "",
        map: null,
        mapItems: []
      };
      cfg.regions = {
        enabled: true,
        regionSelector: "header .regions .controls",
        regionContainer: "header .regions .selection",
        itemSelector: ".region-item",
        confirmButton: ".confirm-region",
        closeSelector: ".close-region",
        surgicalPin: "/wp-content/themes/lyquix-child/images/location-icons/map-SL-pin.png",
        officePin: "/wp-content/themes/lyquix-child/images/location-icons/map-office-pin.png",
        searchSelector: ".office-filters .input-wrapper input",
        searchButton: ".office-filters .input-wrapper button",
        milesSelector: ".office-filters .input-wrapper select",
        locationSelector: ".office-filters .manual-link",
        mobileMapButton: ".map-button-wrapper .map-button",
        mobileListButton: ".map-button-wrapper .list-button"
      };
      if (customCfg)
        cfg.regions = jQuery.extend(true, cfg.regions, customCfg);
      if (cfg.regions.enabled) {
        lqx.log("Initializing module");
        setup();
      }
      vars.regions.init = true;
    };
    const setup = () => {
      jQuery("body, html").on("click", function(e) {
        if (e.target !== jQuery(cfg.regions.regionSelector)[0] && !jQuery(e.target).closest(cfg.regions.regionSelector).length && !jQuery(e.target).closest(cfg.regions.regionContainer).length && jQuery(e.target).attr("id") !== "select-your-region") {
          jQuery(cfg.regions.regionContainer).removeClass("open");
        }
      });
      jQuery(cfg.regions.regionSelector).on("click", function() {
        jQuery(cfg.regions.regionContainer).toggleClass("open");
      });
      jQuery(cfg.regions.itemSelector).on("click", function() {
        jQuery(cfg.regions.confirmButton).attr("data-region", jQuery(this).attr("data-region"));
        jQuery(cfg.regions.itemSelector).removeClass("active");
        jQuery(this).addClass("active");
      });
      jQuery(cfg.regions.confirmButton).on("click", function() {
        const selectedRegion = jQuery(this).attr("data-region");
        if (selectedRegion) {
          document.cookie = `selectedRegion=${selectedRegion}; path=/; max-age=31536000`;
          window.location.reload();
        }
      });
      jQuery(cfg.regions.mobileMapButton).on("click", function() {
        jQuery(".office-container").addClass("map-open").removeClass("list-open");
      });
      jQuery(cfg.regions.mobileListButton).on("click", function() {
        jQuery(".office-container").addClass("list-open").removeClass("map-open");
      });
      jQuery(cfg.regions.closeSelector).on("click", function() {
        jQuery(cfg.regions.regionContainer).removeClass("open");
      });
      jQuery(".select-office").on("click", function() {
        jQuery(cfg.regions.regionContainer).toggleClass("offices-open");
      });
      jQuery(".office-container .back-link").on("click", function() {
        jQuery(cfg.regions.regionContainer).removeClass("offices-open");
      });
      jQuery(cfg.regions.searchButton).on("click", function() {
        const search_query = jQuery(cfg.regions.searchSelector).val();
        if (search_query && search_query.length > 0) {
          vars.regions.searchQuery = search_query;
          getLocation();
        }
      });
      jQuery(cfg.regions.milesSelector).on("change", function() {
        const search_query = jQuery(cfg.regions.searchSelector).val();
        if (search_query && search_query.length > 0) {
          vars.regions.searchQuery = search_query;
          getLocation();
        }
      });
      jQuery(cfg.regions.locationSelector).on("click", function(e) {
        getLocation(true);
      });
      jQuery(".recommended-regions .back-link, .recommended-regions .active-office").on("click", function() {
        jQuery(cfg.regions.regionContainer).removeClass("rec-regions-open").addClass("offices-open");
      });
      if (typeof google !== "undefined") {
        const args = {
          center: { lat: 39.950251, lng: -75.156647 },
          zoom: 10,
          scrollwheel: true,
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          markers: []
        };
        const regionMap = new google.maps.Map(document.getElementById("office-map"), args);
        regionMap.bounds = new google.maps.LatLngBounds;
        jQuery(".office-list li").each(function(item) {
          vars.regions.mapItems.push(this);
          const lat = jQuery(this).attr("data-lat");
          const lon = jQuery(this).attr("data-lon");
          const title = jQuery(this).attr("data-title");
          const type = jQuery(this).attr("data-type");
          const rec_region = jQuery(this).attr("data-region");
          if (type == "office") {
            var markerIcon = cfg.regions.officePin;
          } else if (type == "surgical") {
            var markerIcon = cfg.regions.surgicalPin;
          } else {
            return;
          }
          var googleMapLatLon = new google.maps.LatLng(parseFloat(lat), parseFloat(lon));
          var markerParams = {
            position: googleMapLatLon,
            map: regionMap,
            title,
            label: "",
            icon: markerIcon
          };
          const marker = new google.maps.Marker(markerParams);
          regionMap.markers.push(marker);
          google.maps.event.addListener(marker, "click", function(e) {
            selectRegionFromOffice(markerParams, rec_region);
          });
          jQuery(this).attr("data-marker-index", item);
          jQuery(this).click(function() {
            selectRegionFromOffice(markerParams, rec_region);
          });
          regionMap.bounds.extend(googleMapLatLon);
        });
        regionMap.fitBounds(regionMap.bounds);
        regionMap.panToBounds(regionMap.bounds);
        vars.regions.map = regionMap;
      }
    };
    const selectRegionFromOffice = function(item, region) {
      jQuery(cfg.regions.regionContainer).removeClass("offices-open");
      jQuery(cfg.regions.regionContainer).addClass("rec-regions-open");
      jQuery(".recommended-regions .active-office").text(item.title);
      const target = jQuery('.recommended-regions .region-item[data-region="' + region + '"]');
      const other = jQuery('.recommended-regions .region-item:not([data-region="' + region + '"])');
      jQuery(target).prependTo(".region-list.recommended");
      jQuery(other).prependTo(".region-list.other");
    };
    const getLocation = function(currentLocation = false) {
      if (currentLocation == false) {
        const geocoder = new google.maps.Geocoder;
        geocoder.geocode({ address: vars.regions.searchQuery, region: "us" }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            searchLocations(results[0].geometry.location.lat(), results[0].geometry.location.lng());
          }
        });
      } else {
        navigator.geolocation.getCurrentPosition(function(loc) {
          lqx.log("navigator.done ", loc.coords.latitude, loc.coords.longitude);
          const searchQueryEl = jQuery(cfg.regions.searchSelector);
          searchQueryEl.attr("data-lat", loc.coords.latitude);
          searchQueryEl.attr("data-lon", loc.coords.longitude);
          searchLocations(loc.coords.latitude, loc.coords.longitude);
        });
      }
    };
    const searchLocations = function(lat1, lon1) {
      var locdis = [];
      const filterMiles = parseInt(jQuery(cfg.regions.milesSelector).val());
      vars.regions.map.bounds = new google.maps.LatLngBounds;
      const itemLatLon = new google.maps.LatLng(lat1, lon1);
      const deg2rad = function(deg) {
        return deg * (Math.PI / 180);
      };
      vars.regions.map.bounds.extend(itemLatLon);
      jQuery(cfg.regions.searchSelector).attr("data-lat", lat1);
      jQuery(cfg.regions.searchSelector).attr("data-lon", lon1);
      jQuery(vars.regions.mapItems).each(function(index) {
        var lat2 = jQuery(this).attr("data-lat");
        var lon2 = jQuery(this).attr("data-lon");
        var R = 3963.1676;
        var dLat = deg2rad(lat2 - lat1);
        var dLon = deg2rad(lon2 - lon1);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        jQuery(this).attr("data-distance", d);
        jQuery(this).find(".distance").html(" (" + d.toFixed(1) + " miles)");
        var type = jQuery(".menu-shared li.active").attr("data-key");
        var newHref = "http://maps.google.com/maps?saddr=" + lat1 + "," + lon1 + "&daddr=" + lat2 + "," + lon2;
        jQuery(this).find("a.get-direction").attr("href", newHref);
        if (d > parseFloat(filterMiles)) {
          jQuery(this).hide();
          vars.regions.map.markers[jQuery(this).attr("data-marker-index")].setVisible(false);
        } else {
          jQuery(this).show();
          var itemLatLon2 = new google.maps.LatLng(lat2, lon2);
          vars.regions.map.bounds.extend(itemLatLon2);
          vars.regions.map.markers[jQuery(this).attr("data-marker-index")].setVisible(true);
        }
      });
      var list = jQuery(".regions .office-list");
      var items = list.children("li");
      items.sort(function(a, b) {
        return jQuery(a).data("distance") - jQuery(b).data("distance");
      });
      list.append(items);
      vars.regions.map.fitBounds(vars.regions.map.bounds);
      vars.regions.map.setCenter(new google.maps.LatLng(lat1, lon1));
      if (vars.searchMarker) {
        vars.searchMarker.setMap(null);
      }
      vars.regions.searchMarker = new google.maps.Marker({
        position: new google.maps.LatLng(lat1, lon1),
        map: vars.regions.map,
        icon: {
          path: "M 125,5 155,90 245,90 175,145 200,230 125,180 50,230 75,145 5,90 95,90 z",
          fillColor: "gold",
          fillOpacity: 1,
          scale: 0.1,
          strokeColor: "goldenrod",
          strokeWeight: 2
        }
      });
    };
    return {
      init
    };
  })();

  // js/custom/scripts/locations-cat.ts
  var locations = (() => {
    const init = (customCfg) => {
      if (vars.locations?.init)
        return;
      vars.locations = {
        init: false,
        adjustMap: {
          active: false,
          timer: null
        },
        filterMode: "regional",
        locationFilterSummary: {
          labels: "",
          search: ""
        },
        activeLocationType: "office",
        filterBarPhy: false,
        mapItems: "",
        searchMarker: null,
        loc_type: "filter-office"
      };
      cfg.locations = {
        enabled: true,
        mapSelector: "#cat-map",
        locationTypes: [
          {
            key: "office",
            label: "Office",
            pinIcon: "map-office-pin.png"
          },
          {
            key: "urgent",
            label: "Urgent Care",
            pinIcon: "map-UC-pin.png"
          },
          {
            key: "surgical",
            label: "Surgical",
            pinIcon: "map-SL-pin.png"
          },
          {
            key: "physical-therapy",
            label: "Physical Therapy",
            pinIcon: "map-pt-pin.png"
          }
        ],
        ptDropdownValues: [
          {
            key: "",
            label: "All Locations"
          },
          {
            key: "5",
            label: "5 Miles"
          },
          {
            key: "10",
            label: "10 Miles"
          },
          {
            key: "25",
            label: "25 Miles"
          },
          {
            key: "50",
            label: "50 Miles"
          },
          {
            key: "100",
            label: "100 Miles"
          }
        ]
      };
      if (customCfg)
        cfg.locations = jQuery.extend(true, cfg.locations, customCfg);
      if (cfg.locations.enabled) {
        lqx.log("Initializing module");
        if (jQuery(".page-locations #cat-map, .page-qcap-locator .cat-map, .page-pt-locator .cat-map").length) {
          initMap();
          initAutoComplete();
          initListeners();
          checkUrlHash();
          jQuery("header").addClass("forced-sticky").addClass("scrolled");
        }
        vars.locations.init = true;
      }
    };
    var initMap = function() {
      vars.region = jQuery("body").attr("regions") ? jQuery("body").attr("regions") : "everywhere";
      lqx.map.setup(jQuery("#cat-map"));
      filterItems();
    };
    var initListeners = function() {
      if (jQuery(".page-locations").length) {
        jQuery(".filter-menu .menu li").click(function() {
          var data = jQuery(this).attr("data-key");
          jQuery("body").attr("data-filter-applied", data);
          var label = jQuery(this).html();
          let value = jQuery(this).attr("data-key");
          jQuery(this).parent().find("> li").each(function(i, item) {
            if (jQuery(item).attr("data-key") === data) {
              jQuery(item).addClass("active");
              jQuery('input[name="xs-type"][value="' + value + '"]').trigger("click");
              vars.activeLocationType = label;
            } else {
              jQuery(item).removeClass("active");
            }
          });
          mapFilter("location-type", value);
          lqx.analytics.sendGAEvent({
            eventCategory: "Locations",
            eventAction: "Type Filter",
            eventLabel: label
          });
        });
        jQuery('input[name="mapMode"]').click(function() {
          mapFilter("regions", jQuery(this).val());
        });
        jQuery(".input-wrapper .use-my-location, .input-section-xs .input-wrapper .use-my-location").click(function() {
          var searchQueryEl = jQuery(".cat-items .input-section .search_query");
          var geocoder = new google.maps.Geocoder;
          geocoder.geocode({ address: searchQueryEl.val(), region: "us" }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              mapSearch2(searchQueryEl, results[0].geometry.location.lat(), results[0].geometry.location.lng());
            }
          });
          lqx.analytics.sendGAEvent({
            eventCategory: "Locations",
            eventAction: "Search",
            eventLabel: jQuery.trim(searchQueryEl.val())
          });
        });
        jQuery(".manual-container .manual-link").click(function() {
          var searchQueryEl = jQuery(".cat-locations .input-section .search_query");
          navigator.geolocation.getCurrentPosition(function(loc) {
            lqx.log("navigator.done ", loc.coords.latitude, loc.coords.longitude);
            searchQueryEl.attr("data-lat", loc.coords.latitude);
            searchQueryEl.attr("data-lon", loc.coords.longitude);
            searchQueryEl.val("Current Location");
            mapSearch2(searchQueryEl, loc.coords.latitude, loc.coords.longitude);
            lqx.analytics.sendGAEvent({
              eventCategory: "Locations",
              eventAction: "My Location",
              eventLabel: loc.coords.latitude + ", " + loc.coords.longitude
            });
          });
        });
        jQuery(document).on("change", ".miles-from", function() {
          mapSearch();
        });
        jQuery(".view-control div").click(function() {
          if (!jQuery(this).hasClass("active")) {
            var mode = jQuery(this).attr("class");
            jQuery(".view-control .active").removeClass("active");
            jQuery(this).addClass("active");
            if (mode == "map") {
              jQuery(".cat-locations").removeClass("items-active");
              jQuery(".cat-locations").addClass("map-active");
            } else {
              jQuery(".cat-locations").addClass("items-active");
              jQuery(".cat-locations").removeClass("map-active");
            }
          }
        });
        jQuery(".filter-control").click(function() {
          jQuery(".cat-locations").addClass("filters-active");
          jQuery("#quick-access-drawer").hide();
        });
        jQuery(".filter-close").click(function() {
          jQuery(".cat-locations").removeClass("filters-active");
          jQuery("#quick-access-drawer").show();
        });
        jQuery(".xs-confirm").click(function() {
          jQuery(".cat-locations").removeClass("filters-active");
          jQuery("#quick-access-drawer").show();
        });
        jQuery(".filter-search-toggle").click(function() {
          jQuery(this).toggleClass("open");
        });
        jQuery(document).on("click", ".location-info-toggle", function() {
          var $toggle = jQuery(this);
          var $icon = $toggle.find(".location-info-toggle-icon");
          var $text = $toggle.find(".location-info-toggle-text");
          if ($toggle.hasClass("open")) {
            $toggle.removeClass("open");
            $icon.text("+");
            $text.text("View Location Information");
          } else {
            $toggle.addClass("open");
            $icon.text("×");
            $text.text("Hide Location Information");
          }
        });
      }
    };
    var mapFilter = function(type, value) {
      console.log(type, value);
      switch (type) {
        case "location-type":
          vars.locations.loc_type = value;
          break;
        case "regions":
          vars.locations.filterMode = value;
          break;
      }
      filterItems();
    };
    var checkUrlHash = function() {
      var hash = window.location.hash.substring(1);
      var hashToFilter = {
        "urgent-care": "filter-uc",
        office: "filter-office",
        surgical: "filter-surgical",
        "physical-therapy": "filter-physical-therapy"
      };
      if (hash && hashToFilter[hash]) {
        var filterKey = hashToFilter[hash];
        jQuery('.filter-menu .menu li[data-key="' + filterKey + '"]').trigger("click");
        jQuery('input[name="xs-type"][value="' + filterKey + '"]').prop("checked", true);
        mapFilter("location-type", filterKey);
        setTimeout(function() {
          if (lqx.vars.map.maps[0] && lqx.vars.map.maps[0].bounds && !lqx.vars.map.maps[0].bounds.isEmpty()) {
            var b = lqx.vars.map.maps[0].bounds;
            lqx.vars.map.maps[0].map.fitBounds(b);
            lqx.vars.map.maps[0].map.panToBounds(b);
            google.maps.event.addListenerOnce(lqx.vars.map.maps[0].map, "idle", function() {
              lqx.vars.map.maps[0].map.fitBounds(b);
            });
          }
        }, 200);
      }
    };
    var filterItems = function() {
      var items = jQuery("#locations-list li");
      let distance = jQuery(".cat-locations #miles-from").val();
      lqx.vars.map.maps[0].bounds = new google.maps.LatLngBounds;
      items.each(function(item) {
        var item_id = jQuery(this).attr("data-id");
        if (vars.locations.loc_type == "filter-physical-therapy" && jQuery(this).hasClass("filter-physical-therapy")) {
          jQuery(this).addClass("pt-active");
          lqx.vars.map.maps[0].markers[item_id].setIcon("/wp-content/themes/lyquix-child/images/location-icons/map-pt-pin.png");
        } else {
          jQuery(this).removeClass("pt-active");
          lqx.vars.map.maps[0].markers[item_id].setIcon(jQuery(this).attr("data-icon"));
        }
        let in_region = false;
        let in_type = false;
        let in_distance = false;
        if (jQuery(this).hasClass(vars.locations.loc_type)) {
          in_type = true;
        }
        if (vars.locations.filterMode == "regional") {
          var region = jQuery("body").attr("data-region");
          if (jQuery(this).hasClass("region-" + region)) {
            in_region = true;
          }
        } else {
          in_region = true;
        }
        if (distance == "all") {
          in_distance = true;
        } else {
          let d = parseFloat(jQuery(this).attr("data-distance"));
          if (d <= distance) {
            in_distance = true;
          }
        }
        if (in_region == false || in_type == false || in_distance == false) {
          jQuery(this).hide();
          lqx.vars.map.maps[0].markers[item_id].setVisible(false);
          jQuery(this).removeClass("visible");
        } else {
          jQuery(this).show();
          lqx.vars.map.maps[0].bounds.extend(new google.maps.LatLng(jQuery(this).attr("data-lat"), jQuery(this).attr("data-lng")));
          lqx.vars.map.maps[0].markers[item_id].setVisible(true);
          jQuery(this).addClass("visible");
        }
      });
      var visibleLocations = jQuery("#locations-list li.visible").length;
      var region_string = vars.locations.filterMode == "regional" ? " in " + jQuery("body").attr("data-region-label") : "";
      var loc_type_string = "";
      switch (vars.locations.loc_type) {
        case "filter-office":
          loc_type_string = "office";
          break;
        case "filter-surgical":
          loc_type_string = "surgical";
          break;
        case "filter-urgent":
          loc_type_string = "urgent care";
          break;
        case "filter-physical-therapy":
          loc_type_string = "physical therapy";
          break;
      }
      jQuery(".filters-summary").html("Showing " + visibleLocations + " " + loc_type_string + " locations" + region_string);
      if (!lqx.vars.map.maps[0].bounds.isEmpty()) {
        var boundsToFit = lqx.vars.map.maps[0].bounds;
        lqx.vars.map.maps[0].map.fitBounds(boundsToFit);
        lqx.vars.map.maps[0].map.panToBounds(boundsToFit);
        google.maps.event.addListenerOnce(lqx.vars.map.maps[0].map, "idle", function() {
          lqx.vars.map.maps[0].map.fitBounds(boundsToFit);
        });
      }
    };
    var mapSearch2 = function(searchQueryEl, lat1, lon1) {
      if (searchQueryEl.val()) {
        var deg2rad = function(deg) {
          return deg * (Math.PI / 180);
        };
        var filterMiles = parseInt(jQuery(".tmpl-custom-locations .input-section select#miles-from option:checked").val());
        searchQueryEl.attr("data-lat", lat1);
        searchQueryEl.attr("data-lon", lon1);
        jQuery("#locations-list li").each(function(index) {
          var lat2 = jQuery(this).attr("data-lat");
          var lon2 = jQuery(this).attr("data-lng");
          var R = 3963.1676;
          var dLat = deg2rad(lat2 - lat1);
          var dLon = deg2rad(lon2 - lon1);
          var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          var d = R * c;
          jQuery(this).attr("data-distance", d);
          d = d.toFixed(1);
          jQuery(this).find(".miles-from").html(d + " miles");
          lqx.log(d, parseFloat(filterMiles));
          var type = jQuery(".menu-shared li.active").attr("data-key");
          var newHref = "http://maps.google.com/maps?saddr=" + lat1 + "," + lon1 + "&daddr=" + lat2 + "," + lon2;
          jQuery(this).find("a.get-direction").attr("href", newHref);
          if (d > parseFloat(filterMiles)) {
            jQuery(this).hide();
          } else if (jQuery(this).hasClass(type)) {
            jQuery(this).show();
          }
          if (lqx.vars.map.maps[0].infoWindows[jQuery(this).attr("data-itemid")]) {
            var newObject = jQuery(lqx.vars.map.maps[0].markers[jQuery(this).attr("data-itemid")].html);
            newObject.find(".get-direction").attr("href", newHref);
            lqx.vars.map.maps[0].markers[jQuery(this).attr("data-itemid")].html = jQuery("<div>").append(newObject.clone()).html();
          }
        });
        var locdis = [];
        jQuery("#locations-list li").each(function() {
          var i2 = jQuery(this).attr("data-id");
          var d = parseFloat(jQuery(this).attr("data-distance"));
          var c = this.outerHTML;
          locdis.push({
            i: i2,
            d,
            c
          });
        });
        locdis.sort(function(a, b) {
          if (parseFloat(a.d) < parseFloat(b.d))
            return 1;
          if (parseFloat(a.d) > parseFloat(b.d))
            return -1;
          return 0;
        });
        var newhtml = "";
        jQuery("#locations-list").empty();
        for (var i = locdis.length;i > 0; i--) {
          newhtml = newhtml + locdis[i - 1].c;
        }
        jQuery(newhtml).prependTo(jQuery("#locations-list"));
        if (vars.searchMarker) {
          vars.searchMarker.setMap(null);
        }
        vars.searchMarker = new google.maps.Marker({
          position: new google.maps.LatLng(lat1, lon1),
          map: lqx.vars.map.maps[0].map,
          icon: {
            path: "M 125,5 155,90 245,90 175,145 200,230 125,180 50,230 75,145 5,90 95,90 z",
            fillColor: "gold",
            fillOpacity: 1,
            scale: 0.1,
            strokeColor: "goldenrod",
            strokeWeight: 2
          }
        });
        filterItems();
      } else {
        alert("Please enter an address or city/state to search");
      }
    };
    var mapSearch = function() {
      var searchQueryEl = jQuery(".input-section .search_query");
      var mode = ((vars.place || "").geometry || "") !== "" ? "autocomplete" : "not-autocomplete";
      var lat1 = searchQueryEl.attr("data-lat");
      var lon1 = searchQueryEl.attr("data-lon");
      if (mode === "autocomplete") {
        lat1 = vars.place.geometry.location.lat();
        lon1 = vars.place.geometry.location.lng();
        lqx.log("autocomplete ", lat1, lon1);
        mapSearch2(searchQueryEl, lat1, lon1);
      } else {
        if (searchQueryEl.val() !== "Current Location") {
          lqx.log("NOT autocomplete, latlon NOT found ");
          var geocoder = new google.maps.Geocoder;
          geocoder.geocode({ address: searchQueryEl.val(), region: "us" }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              lqx.log("after geocode ", status, results);
              mapSearch2(searchQueryEl, results[0].geometry.location.lat(), results[0].geometry.location.lng());
            }
          });
        } else {
          if (lat1 && lon1) {
            mapSearch2(searchQueryEl, lat1, lon1);
          }
        }
      }
    };
    var initAutoComplete = function() {
      var input = document.getElementById("pac-input");
      var autocompleteOptions = {
        componentRestrictions: { country: "us" }
      };
      var fieldsNeeded = ["geometry", "formatted_address"];
      var autocomplete = new google.maps.places.Autocomplete(input, autocompleteOptions);
      autocomplete.setFields(fieldsNeeded);
      autocomplete.addListener("place_changed", function() {
        vars.place = autocomplete.getPlace();
        mapSearch();
        var catItems = jQuery("#locations-list").parent();
        if (jQuery(input).val().length <= 0) {
          catItems.removeClass("show-results");
        } else {
          if (!catItems.hasClass("show-results"))
            catItems.addClass("show-results");
        }
        var searchQueryEl = jQuery(".cat-items .input-section .search_query");
        lqx.analytics.sendGAEvent({
          eventCategory: "Locations",
          eventAction: "Search",
          eventLabel: jQuery.trim(searchQueryEl.val())
        });
      });
    };
    return {
      init
    };
  })();

  // js/custom/scripts/infographic.ts
  var infographic = (() => {
    const init = (customCfg) => {
      if (vars.infographic?.init)
        return;
      vars.infographic = {
        init: false
      };
      cfg.infographic = {
        enabled: true
      };
      if (customCfg)
        cfg.infographic = jQuery.extend(true, cfg.infographic, customCfg);
      if (cfg.infographic.enabled) {
        lqx.log("Initializing infographic");
        if (jQuery('body .lqx-block-cards[data-preset="infographic"]').length) {
          jQuery(function($) {
            const $root = $('.lqx-block-cards[data-preset="infographic"]');
            $root.on("click", ".card", function() {
              const $clickedCard = $(this);
              const $cardsContainer = $clickedCard.closest(".cards");
              if ($cardsContainer.hasClass("swiper-initialized"))
                return;
              const $ul = $cardsContainer.find("ul.cards-wrapper");
              const clickedIndex = $clickedCard.index();
              $ul.removeClass("cards-wrapper").addClass("swiper-wrapper");
              $ul.find("li.card").removeClass("card").addClass("swiper-slide");
              $ul.wrap('<div class="swiper"></div>');
              const $swiperEl = $cardsContainer.find("> .swiper");
              $cardsContainer.find("[data-swiper-chrome]").remove();
              const $chrome = $(`
        <div class="swiper-close" role="button" tabindex="0" aria-label="Close slider" title="Close slider">
                    <img alt="close" src="/wp-content/themes/lyquix-child/images/icons/infographic/close-button.svg">
        </div>
        <div class="swiper-chrome" data-swiper-chrome>
          <div class="swiper-controls">
            <div class="swiper-pagination" aria-label="Slide pagination"></div>
            <div class="swiper-inner-nav">
              <div class="swiper-button-prev" role="button" tabindex="0" aria-label="Previous slide" title="Previous service"></div>
              <div class="swiper-button-next" role="button" tabindex="0" aria-label="Next slide" title="Next service"></div>
            </div>
          </div>
        </div>
      `);
              $cardsContainer.append($chrome);
              const swiper = new Swiper($swiperEl[0], {
                effect: "fade",
                fadeEffect: { crossFade: true },
                speed: 400,
                loop: false,
                autoHeight: true,
                slidesPerView: 1,
                initialSlide: clickedIndex,
                navigation: {
                  nextEl: $cardsContainer.find(".swiper-button-next")[0],
                  prevEl: $cardsContainer.find(".swiper-button-prev")[0]
                },
                pagination: {
                  el: $cardsContainer.find(".swiper-pagination")[0],
                  clickable: true,
                  renderBullet(index, className) {
                    return `<span class="${className} my-bullet-${index}" aria-label="Go to slide ${index + 1}"></span>`;
                  }
                }
              });
              $cardsContainer.data("swiper", swiper).addClass("swiper-initialized");
            });
            $root.on("keydown", '.swiper-close[role="button"]', function(e) {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                $(this).trigger("click");
              }
            });
            $root.on("click", ".swiper-close", function(e) {
              e.preventDefault();
              closeSlider($(this).closest(".cards"));
            });
            function closeSlider($cardsContainer) {
              const swiper = $cardsContainer.data("swiper");
              if (swiper) {
                swiper.destroy(true, true);
                $cardsContainer.removeData("swiper");
              }
              const $swiper = $cardsContainer.find("> .swiper");
              const $ul = $swiper.find("ul.swiper-wrapper");
              $ul.unwrap();
              $ul.removeClass("swiper-wrapper").addClass("cards-wrapper");
              $ul.find("li.swiper-slide").removeClass("swiper-slide").addClass("card");
              $cardsContainer.find("[data-swiper-chrome], .swiper-close").remove();
              $cardsContainer.removeClass("swiper-initialized");
            }
          });
        }
      }
      vars.infographic.init = true;
    };
    return {
      init
    };
  })();

  // js/custom/scripts/physicians.ts
  var physicians = (() => {
    const init = (customCfg) => {
      if (vars.physicians?.init)
        return;
      vars.physicians = {
        init: false
      };
      cfg.physicians = {
        enabled: true
      };
      if (customCfg)
        cfg.module = jQuery.extend(true, cfg.module, customCfg);
      if (cfg.physicians.enabled) {
        lqx.log("Initializing physicians");
        if (jQuery(".lqx-block-filters[data-preset=physicians-archive]").length) {
          jQuery(function($) {
            $(document).on("click", ".filter-toggle", function() {
              $(".additional-controls").toggleClass("mobile-open");
            });
          });
        }
        jQuery(function($) {
          $("[data-tab]").on("click", function() {
            $(".location-tab").removeClass("active");
            $(this).addClass("active");
            $(".location-content").addClass("hidden");
            $("#" + $(this).data("tab") + "-locations").removeClass("hidden");
          });
          $("[data-content-tab]").on("click", function() {
            $(".content-tab").removeClass("active");
            $(this).addClass("active");
            $("[data-toggle-content]").addClass("hidden");
            $("[data-toggle-content=" + $(this).data("content-tab") + "]").removeClass("hidden");
          });
          $(".view-address").on("click", function() {
            $(this).parent().find(".expander").toggleClass("expanded");
            var span = $(this).find("span");
            var current = span.text();
            span.text(current === "+ View Address" ? "- Hide Address" : "+ View Address");
          });
          $(".read-more-btn").on("click", function() {
            var current = $(this).text();
            $(this).text(current === "Read More" ? "Read Less" : "Read More");
            $(".content-grid-inner").toggleClass("expanded");
          });
          $(".returning-patient").on("click", function(e) {
            if ($(e.target).hasClass("close-x"))
              return;
            $(this).find(".returning-patient-tooltip").addClass("active");
          });
          $(".close-x").on("click", function() {
            $(this).parent().removeClass("active");
          });
          lqx.mutation.addHandler("addNode", ".publications-loader[data-post-id]", (node) => {
            const $loader = $(node);
            const postId = parseInt($loader.data("post-id"));
            if (!postId)
              return;
            const ajaxCfg = window.rothmanAjax || {};
            $.post(ajaxCfg.url, {
              action: "get_physician_publications",
              post_id: postId,
              nonce: ajaxCfg.nonce
            }).done(function(response) {
              if (response.success)
                $loader.html(response.data.html);
              else
                $loader.remove();
            }).fail(function() {
              $loader.remove();
            });
          });
          $(document).on("click", ".lqx-block-filters[data-preset=physicians-archive] .sort-toggle", function() {
            $(this).parent().toggleClass("open");
          });
          $(document).on("click", ".lqx-block-filters[data-preset=physicians-archive] .distance-sort-wrapper .option", function() {
            $(".distance-sort-wrapper .option").removeClass("selected");
            $(this).addClass("selected");
            $(".sort-toggle .selected").text($(this).text());
          });
          $(document).on("click", ".additional-controls .mobile-close-filter", function() {
            $(".additional-controls").removeClass("mobile-open");
            $('[data-view="filter"]').addClass("active");
            $('[data-view="sort"]').removeClass("active");
            $('[data-toggle-view="filter"]').show();
            $('[data-toggle-view="sort"]').hide();
          });
          $(window).on("resize", function() {
            if ($(window).width() >= 720) {
              $('[data-toggle-view="sort"]').show();
              $(".additional-controls").removeClass("mobile-open");
            } else {
              $('[data-toggle-view="sort"]').hide();
            }
          });
          $(document).on("click", ".additional-controls .view", function() {
            $(".view").removeClass("active");
            $(this).addClass("active");
            $("[data-toggle-view]").hide();
            $("[data-toggle-view=" + $(this).data("view") + "]").show();
          });
          $(document).on("click", function(e) {
            if (!$(e.target).closest(".distance-sort-wrapper").length) {
              $(".lqx-block-filters[data-preset=physicians-archive] .distance-sort-wrapper .control-wrapper").removeClass("open");
            }
          });
        });
      }
      vars.physicians.init = true;
    };
    return {
      init
    };
  })();

  // js/custom/scripts/treatments-conditions.ts
  var treatments_conditions = (() => {
    const init = (customCfg) => {
      if (vars.treatments_conditions?.init)
        return;
      vars.treatments_conditions = {
        init: false
      };
      cfg.treatments_conditions = {
        enabled: true
      };
      if (customCfg)
        cfg.treatments_conditions = jQuery.extend(true, cfg.treatments_conditions, customCfg);
      if (cfg.treatments_conditions.enabled) {
        lqx.log("Initializing treatments_conditions");
        toggleMode();
        searchInit();
        tcListeners();
        sidebarPositionControl();
        jQuery(window).on("scroll", function() {
          activeSection();
          sidebarPositionControl();
        });
        jQuery(window).on("resize", function() {
          sidebarPositionControl();
        });
      }
      vars.treatments_conditions.init = true;
    };
    var sidebarPositionControl = function() {
      if (jQuery(".cat-conditions").length > 0 || jQuery(".cat-treatments").length > 0) {
        if (jQuery("body").attr("screen") !== "xs" && jQuery("body").attr("screen") !== "sm") {
          var sidebar = jQuery(".sidebar");
          var footerHeight = jQuery("footer").outerHeight();
          var totalHeight = footerHeight;
          if (jQuery(window).scrollTop() + jQuery(window).height() >= jQuery(document).height() - totalHeight) {
            sidebar.css({
              position: "absolute",
              bottom: "0",
              top: "auto"
            });
          } else {
            sidebar.css({
              position: "fixed",
              bottom: "auto",
              top: ""
            });
          }
        } else {
          sidebar.css({
            position: "",
            bottom: "",
            top: ""
          });
        }
      }
    };
    var toggleMode = function() {
      if (jQuery(".cat-treatments").length || jQuery(".cat-conditions").length) {
        jQuery(".specialty-group").on("change", function() {
          const groupBy = jQuery(this).data("groupby");
          if (groupBy === "specialty") {
            jQuery(".tre-list-specialty").removeClass("hidden");
            jQuery(".tre-list-alpha").addClass("hidden");
            jQuery(".sidebar").removeClass("alpha").addClass("specialty");
          } else if (groupBy === "alphabetically") {
            jQuery(".tre-list-specialty").addClass("hidden");
            jQuery(".tre-list-alpha").removeClass("hidden");
            jQuery(".sidebar").addClass("alpha").removeClass("specialty");
          }
          const searchVal = jQuery(".conditions-treatments-search").val();
          if (searchVal && searchVal !== "") {
            searchTC(jQuery(".conditions-treatments-search"));
          }
        });
      }
    };
    var tcListeners = function() {
      if (jQuery(".cat-treatments").length || jQuery(".cat-conditions").length) {
        if (window.location.hash === "#alphabetically") {
          jQuery('input[data-groupby="alphabetically"]').trigger("click");
          jQuery('input[data-groupby="alphabetically"]').prop("checked", true);
        }
        if (window.location.hash === "#specialty") {
          jQuery('input[data-groupby="specialty"]').trigger("click");
          jQuery('input[data-groupby="specialty"]').prop("checked", true);
        }
        jQuery(".sidebar .jump-to").on("click", function() {
          if (jQuery(this).hasClass("alpha-letter")) {
            var target = jQuery(this).attr("data-target");
            var offset = jQuery('.tre-list-alpha > li[data-target="' + target + '"]').offset().top - jQuery("header").outerHeight(true);
          } else {
            var target = jQuery(this).attr("data-target");
            var offset = jQuery('.tre-list-specialty > li[data-target="' + target + '"]').offset().top - jQuery("header").outerHeight(true);
          }
          jQuery("html, body").animate({
            scrollTop: offset
          }, 0);
        });
      }
    };
    var searchInit = function() {
      if (jQuery(".cat-treatments").length || jQuery(".cat-conditions").length) {
        var search = jQuery(".conditions-treatments-search");
        var searchToggle = jQuery(".search-toggle");
        var lunrDocsSpecialty = [];
        var lunrDocsAlpha = [];
        jQuery(".tre-list-alpha > li ul li").each(function(i, elem) {
          lunrDocsAlpha.push({
            id: i,
            title: jQuery(elem).find("a").text().toLowerCase()
          });
        });
        jQuery(".tre-list-specialty > li > ul li").each(function(i, elem) {
          lunrDocsSpecialty.push({
            id: i,
            title: jQuery(elem).find("a").text().toLowerCase()
          });
        });
        vars.idxAlpha = lunr(function() {
          this.ref("id");
          this.field("title");
          lunrDocsAlpha.forEach(function(doc) {
            this.add(doc);
          }, this);
        });
        vars.idxSpecialty = lunr(function() {
          this.ref("id");
          this.field("title");
          lunrDocsSpecialty.forEach(function(doc) {
            this.add(doc);
          }, this);
        });
        jQuery(".conditions-treatments-search").on("keyup", function(e) {
          if (e.keyCode === 13) {
            searchTC(search);
          }
        });
        searchToggle.on("click", function() {
          searchTC(search);
        });
      }
    };
    var searchTC = function(search) {
      var value = search.val().toLowerCase();
      if (jQuery(".sidebar").hasClass("alpha")) {
        var results = vars.idxAlpha.search(value);
      } else {
        var results = vars.idxSpecialty.search(value);
      }
      jQuery(".tre-list-specialty > li > ul li").hide();
      jQuery(".tre-list-specialty > li").hide();
      jQuery(".tre-list-alpha > li ul li").hide();
      jQuery(".sidebar > h3").hide();
      jQuery(".sidebar .alpha-letters li").hide();
      jQuery(".tre-list-specialty > li > h3").hide();
      jQuery(".tre-list-alpha > li h3").hide();
      jQuery.each(results, function(idx, result) {
        if (jQuery(".sidebar").hasClass("alpha")) {
          jQuery(".tre-list-alpha > li ul li").eq(result.ref).show();
          jQuery(".tre-list-alpha > li ul li").eq(result.ref).parent().parent().find("h3").show();
          var text = jQuery(".tre-list-alpha > li ul li").eq(result.ref).parent().parent().find("h3").text();
          console.log("TEXT: " + text);
          var target = text.replace(/\s+/g, "-").toLowerCase();
          jQuery(".sidebar .alpha-letters li").each(function() {
            if (jQuery(this).find("h3").text().toLowerCase() === target) {
              jQuery(this).show();
            }
          });
        } else {
          jQuery(".tre-list-specialty > li > ul li").eq(result.ref).show();
          jQuery(".tre-list-specialty > li > ul li").eq(result.ref).parent().parent().show();
          jQuery(".tre-list-specialty > li > ul li").eq(result.ref).parent().parent().find("h3").show();
          var text = jQuery(".tre-list-specialty > li > ul li").eq(result.ref).parent().parent().find("h3").text();
          var target = text.replace(/\s+/g, "-").toLowerCase();
          jQuery('.sidebar h3[data-target="' + target + '"]').show();
        }
      });
      if (results.length === 0) {
        var noResults = '<div class="no-results"><h2>No results</h2><p>Please try entering another search term.</p></div>';
        jQuery(noResults).appendTo(".section-1");
      } else {
        jQuery(".no-results").remove();
      }
    };
    const activeSection = function() {
      if (jQuery(".cat-treatments").length || jQuery(".cat-conditions").length) {
        if (jQuery(window).scrollTop() > 136) {
          jQuery(".sidebar").addClass("active");
        } else {
          jQuery(".sidebar").removeClass("active");
        }
        jQuery(".tre-list-alpha > li").each(function() {
          var target = jQuery(this).attr("data-target");
          var offset = parseInt(jQuery(this).offset().top - jQuery("header").outerHeight(true));
          if (jQuery(window).scrollTop() >= offset) {
            jQuery(".sidebar .alpha-letters li").removeClass("active");
            jQuery('.sidebar .alpha-letters li:contains("' + target.toUpperCase() + '")').addClass("active");
          }
        });
        jQuery(".tre-list-specialty > li").each(function() {
          var target = jQuery(this).attr("data-target");
          var offset = jQuery(this).offset().top - jQuery("header").outerHeight(true);
          if (jQuery(window).scrollTop() >= offset) {
            jQuery(".sidebar .specialty-list li").removeClass("active");
            jQuery('.sidebar .specialty-list li[data-target="' + target + '"]').addClass("active");
          }
        });
        if (jQuery(window).scrollTop() == 0) {
          jQuery(".sidebar .alpha-letters li").removeClass("active");
          jQuery(".sidebar .alpha-letters li:first-child").addClass("active");
          jQuery(".sidebar .specialty-list li").removeClass("active");
          jQuery(".sidebar .specialty-list li:first-of-type").addClass("active");
        }
      }
    };
    return {
      init
    };
  })();

  // js/custom/scripts/misc.ts
  var misc = (() => {
    const init = (customCfg) => {
      if (vars.misc?.init)
        return;
      vars.misc = {
        init: false,
        rpMap: null,
        searchQuery: "",
        prLunrDocsText: null,
        prLunrIdxText: null,
        prResultList: null,
        searchBox: {
          searchLimit: 3,
          searchThrottle: false,
          searchThrottleCap: false,
          keyNotValidArray: [
            9,
            27,
            35,
            36,
            37,
            38,
            39,
            40,
            45,
            16,
            17,
            18,
            19,
            20,
            33,
            34,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            144
          ],
          query: "",
          suggestion: "",
          suggestionQueue: [],
          cache: {
            suggestions: {},
            results: {}
          },
          menuCollapse: {
            lg: 98,
            md: 98,
            sm: 98
          }
        }
      };
      cfg.misc = {
        enabled: true
      };
      if (customCfg)
        cfg.misc = jQuery.extend(true, cfg.misc, customCfg);
      if (cfg.misc.enabled) {
        lqx.log("Initializing misc");
        makeAnAppointmentLightBox();
        appointmentTimeCheck();
        bodyPartSlider();
        hurtAppControl();
        relatedPhysicians();
        locationsDirections();
        servicesLocations();
        yourVisitTabNavigation();
        patientResourcesSearchInit();
        servicesMapSmall();
        appointmentOOR();
        appointmentNoShow();
        specialtiesNavTabs();
        mapRegionFocus();
        nyRegionAlert();
      }
      vars.misc.init = true;
    };
    var makeAnAppointmentLightBox = function() {
      lqx.vars.document.on("click", ".make-an-appointment-trigger", function() {
        var isPhysiciansPage = jQuery(".page-physicians, .single-physicians, .related-physicians").length;
        console.log(isPhysiciansPage);
        var appointmentUrl = jQuery(this).attr("data-appointment-url");
        var physicianName = jQuery(this).attr("data-phy-name");
        var headshotURL = jQuery(this).attr("data-phy-img");
        var firstTimePatientURL = "/contact/appointments/make-an-appointment-first-time-patient";
        var returningPatientURL = "/contact/appointments/make-an-appointment-returning-patients";
        var workersCompURL = "/contact/referring-physicians-and-athletic-trainers/appointment-request";
        var onlineSchedulingTooltipText = "Provide us with some information and we will call you back to complete scheduling your appointment. Schedule both office and virtual visits.";
        var callText = "Talk with one of our agents to schedule your appointment";
        var onlineText = "Schedule your in-person appointment entirely online and in real time.<br/>Available for first time and returning patients.";
        var requestCallbackTooltipText = "Provide us with some information and we will call you back to complete scheduling your appointment. Office visits only";
        var phyPhone = jQuery(this).attr("data-phy-phone");
        var html = '<div class="lightbox-overlay"></div><div class="make-an-appointment-lightbox make-an-appointment"><div class="inner"><div class="lightbox-wrapper"><div class="close-x" id="closeAppointmentLightBox"></div><div class="heading-wrapper"><div class="h1">Make an Appointment</div>';
        if (isPhysiciansPage) {
          html += '<div class="flex-container headshot-row"><img class="headshot" src="' + headshotURL + '"><h3 class="phy-name">' + physicianName + "</h3></div>";
        }
        html += "</div>" + '<div class="cmn-container-wrapper">';
        html += '<div class="cmn-container region-name-outside-region"><div class="select-region-message filter-message"><div class="inner"><h2>Please select your region to make an appointment.</h2><a id="lightbox-select-your-region" class="button-yellow"> Select Your Region</a></div></div></div>';
        if (physicianName !== "Jeremy I. Simon, MD" && appointmentUrl !== "" && appointmentUrl !== undefined)
          html += '<div class="online-scheduling cmn-container"><div class="heading-row"><h3><a href="' + appointmentUrl + '">Online Scheduling</a></h3><span class="details-circle"><div class="tool-tip">' + onlineText + "</div></span></div></div>";
        html += '<div class="call cmn-container"><div class="heading-row"><h3>Call ';
        if (phyPhone) {
          var phyPhoneClean = phyPhone.replace(/\D/g, "");
          var phyPhoneFormatted = phyPhoneClean.replace(/^(1)(\d{3})(\d{3})(\d{4})$/, "$1-$2-$3-$4");
          phyPhoneFormatted = phyPhoneFormatted.replace(/^(\d{3})(\d{3})(\d{4})$/, "$1-$2-$3");
          html += '<a href="tel:' + phyPhoneClean + '">' + phyPhoneFormatted + "</a>";
        } else {
          html += '<a class="region-name-greater-philadelphia" href="tel:1-800-321-9999">1-800-321-9999</a>' + '<a class="region-name-florida" href="tel:1-844-407-4070">1-844-407-4070</a>' + '<a class="region-name-ny-north-jersey" href="tel:1-888-636-7840">1-888-636-7840</a>';
        }
        html += "</h3></div></div>";
        html += '</div></div><div class="alert-bottom"><p>If you are experiencing a medical emergency, please do not submit an online request. Instead, call 911 immediately!</p></div></div></div>';
        jQuery(html).appendTo("body").hide().fadeIn(300);
        jQuery("body").addClass("no-scroll");
      });
      lqx.vars.document.on("click", "#closeAppointmentLightBox, .lightbox-overlay", function() {
        jQuery(".lightbox-overlay, .make-an-appointment-lightbox").fadeOut("normal", function() {
          jQuery("body").addClass("no-scroll");
          jQuery(this).remove();
        });
      });
      lqx.vars.document.on("click", "#lightbox-select-your-region", function() {
        jQuery("#closeAppointmentLightBox").trigger("click");
        if (!jQuery("#region-filter .region-selector.active").length) {
          jQuery("#region-filter .controls").click();
        }
      });
      lqx.vars.document.on("click", ".toggle-callback-links", function() {
        jQuery(this).closest(".cmn-container").toggleClass("open");
      });
      lqx.vars.document.on("click", ".make-an-appointment-lightbox .details-circle", function(e) {
        var parentContainer = jQuery(this).closest(".cmn-container");
        parentContainer.siblings().removeClass("tool-tip-open");
        parentContainer.toggleClass("tool-tip-open");
      });
      lqx.vars.document.on("click", ".make-an-appointment-lightbox .tool-tip", function(e) {
        e.stopPropagation();
      });
    };
    var appointmentTimeCheck = function() {
      if (jQuery(".make-an-appointment").length) {
        const now = new Date;
        const currentMinutes = now.getHours() * 60 + now.getMinutes();
        const startMinutes = 17 * 60 + 30;
        const endMinutes = 21 * 60 + 30;
        if (currentMinutes >= startMinutes && currentMinutes <= endMinutes) {
          jQuery(".phone-number-block .unavailable").removeClass("hide");
        }
      }
    };
    var bodyPartSlider = function() {
      if (jQuery(".body-part-slider").length) {
        jQuery(".body-part-slider .open-body-part, .body-part-slider .open-full-text").on("click", function() {
          jQuery(this).closest(".body-part-slider").addClass("expanded");
        });
        jQuery(".body-part-slider .close-body-part").on("click", function() {
          jQuery(this).closest(".body-part-slider").removeClass("expanded");
        });
      }
    };
    var hurtAppControl = function() {
      if (jQuery(".hurt-app.locations-category").length) {
        jQuery(".hurt-app .close").click(function() {
          jQuery(".hurt-app.locations-category").detach();
        });
      }
    };
    var relatedPhysicians = function() {
      if (jQuery(".related-physicians, .page-physicians").length) {
        console.log("in correct place");
        setTimeout(sizeListControls, 50);
        jQuery(document).on("ajaxComplete", function() {
          setTimeout(sizeListControls, 50);
        });
        jQuery(".distance-sort-wrapper .open").click(function() {
          jQuery(this).closest(".distance-sort-wrapper").addClass("expanded");
        });
        jQuery(".distance-sort-wrapper .close").click(function() {
          jQuery(this).closest(".distance-sort-wrapper").removeClass("expanded");
        });
        jQuery(".related-physicians .mobile-menu-controls").click(function() {
          jQuery(".related-physicians .controls").toggleClass("mobile-open");
        });
        jQuery(".related-physicians .view-control .view").click(function() {
          const view = jQuery(this).attr("data-view");
          jQuery(".related-physicians .view-control .view").removeClass("active");
          jQuery(this).addClass("active");
          jQuery(".related-physicians .controls-wrapper").attr("data-view", view);
        });
        jQuery('.control-wrapper[data-control="office"] .mobile-view-switch .view').click(function() {
          const view = jQuery(this).attr("data-view");
          jQuery('.control-wrapper[data-control="office"] .dropdown-wrapper').attr("data-view", view);
        });
        jQuery('.control-wrapper[data-control="office"] .mobile-close').click(function() {
          jQuery('.control-wrapper[data-control="office"]').removeClass("open");
        });
        if (jQuery('.control-wrapper[data-control="office"]').length) {
          console.log("filter exists");
          const mapSelector = "related-physicians-map";
          const mapItems = jQuery('[data-control="office"] .option');
          let mapItemsProcessed = [];
          let index = 0;
          jQuery(mapItems).each(function() {
            if (jQuery(this).text() !== "all") {
              const title = jQuery(this).attr("data-title");
              const type = jQuery(this).attr("data-type");
              let icon = "";
              if (type == "office") {
                icon = "/wp-content/themes/lyquix-child/images/location-icons/map-office-pin.svg";
              } else {
                icon = "/wp-content/themes/lyquix-child/images/location-icons/map-SL-pin.svg";
              }
              const itemData = {
                lat: jQuery(this).attr("data-lat"),
                lon: jQuery(this).attr("data-lon"),
                type,
                distance: jQuery(this).attr("data-distance"),
                title,
                value: jQuery(this).attr("data-value"),
                icon
              };
              if (itemData.lat !== "" && itemData.lat !== undefined) {
                jQuery(this).attr("data-marker-index", index);
                mapItemsProcessed.push(itemData);
                index++;
              }
            }
          });
          const lqxMap = {
            map: null,
            options: {
              scrollWheel: true,
              mapTypeControl: false,
              panControl: true,
              zoomControl: true,
              gestureHandling: "normal",
              streetViewControl: false,
              fullscreenControl: false,
              zoom: 1
            },
            center: new google.maps.LatLng(0, 0),
            bounds: new google.maps.LatLngBounds,
            items: mapItemsProcessed,
            infoWindows: {},
            markers: {},
            groupedItems: []
          };
          lqxMap.options.mapTypeId = google.maps.MapTypeId[lqxMap.options.mapTypeId];
          lqxMap.map = new google.maps.Map(document.getElementById(mapSelector), lqxMap.options, lqxMap.options);
          for (let i = 0;i < lqxMap.items.length; i++) {
            console.log("hit the item: ", lqxMap.items[i]);
            const itemLatLon = new google.maps.LatLng(lqxMap.items[i].lat, lqxMap.items[i].lon);
            lqxMap.bounds.extend(itemLatLon);
            const itemid = lqxMap.items[i].value;
            if (lqxMap.items[i].infoWindow == true)
              lqxMap.infoWindows[itemid] = new google.maps.InfoWindow({ content: lqxMap.items[i].html });
            const markerParams = {
              position: itemLatLon,
              map: lqxMap.map,
              title: lqxMap.items[i].title,
              id: lqxMap.items[i].value,
              icon: lqxMap.items[i].icon
            };
            if (lqxMap.items[i].icon != "")
              markerParams.icon = {
                url: lqxMap.items[i].icon
              };
            lqxMap.markers[itemid] = new google.maps.Marker(markerParams);
            if (lqxMap.items[i].type == "surgical")
              lqxMap.markers[itemid].setVisible(false);
            google.maps.event.addListener(lqxMap.markers[itemid], "click", function() {
              jQuery('[data-control="office"] .option[data-value="' + lqxMap.markers[itemid].id + '"]').trigger("click");
            });
          }
          lqxMap.map.fitBounds(lqxMap.bounds);
          lqxMap.map.panToBounds(lqxMap.bounds);
          vars.misc.rpMap = lqxMap;
          jQuery(".input-checkbox").click(function() {
            console.log("detected checkbox change");
            jQuery(this).toggleClass("active");
            const value = jQuery(this).attr("data-value");
            if (jQuery(this).hasClass("active")) {
              jQuery('.control-wrapper[data-control="office"] .control-list').addClass(value);
              jQuery('.control-wrapper[data-control="office"] .control-list .option[data-type="' + value + '"]').each(function() {
                vars.misc.rpMap.markers[parseInt(jQuery(this).attr("data-value"))].setVisible(true);
              });
            } else {
              jQuery('.control-wrapper[data-control="office"] .control-list').removeClass(value);
              jQuery('.control-wrapper[data-control="office"] .control-list .option[data-type="' + value + '"]').each(function() {
                if (jQuery(this).attr("data-marker-index")) {
                  vars.misc.rpMap.markers[parseInt(jQuery(this).attr("data-value"))].setVisible(false);
                }
              });
            }
          });
          const searchField = jQuery(".phy-loc-dropdown-text-input");
          jQuery(".manual-container").click(function() {
            console.log("detected manual click");
            navigator.geolocation.getCurrentPosition(function(loc) {
              lqx.log("navigator.done ", loc.coords.latitude, loc.coords.longitude);
              searchLocations(loc.coords.latitude, loc.coords.longitude);
            });
          });
          jQuery("#phy-loc-dropdown-text-input").keypress(function(e) {
            console.log("detected keystroke");
            if (e.which == 13) {
              const val = searchField.val();
              if (val !== "") {
                const geocoder = new google.maps.Geocoder;
                geocoder.geocode({ address: val, region: "us" }, function(results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {
                    console.log("made it to geocoder completion: ", results);
                    searchLocations(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                  } else {
                    console.log("didn't make it to geocoder completion: ", google.maps.GeocoderStatus);
                  }
                });
              }
            }
          });
          jQuery(".left-column-and-map-wrapper .input-section .submit-button").click(function() {
            console.log("detected click");
            const val = searchField.val();
            if (val !== "") {
              const geocoder = new google.maps.Geocoder;
              geocoder.geocode({ address: val, region: "us" }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                  console.log("made it to geocoder completion: ", results);
                  searchLocations(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                } else {
                  console.log("didn't make it to geocoder completion: ", google.maps.GeocoderStatus);
                }
              });
            }
          });
          jQuery(".left-column-and-map-wrapper .input-section #miles-from").change(function() {
            console.log("detected change");
            const val = searchField.val();
            if (val !== "") {
              const geocoder = new google.maps.Geocoder;
              geocoder.geocode({ address: val, region: "us" }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                  console.log("made it to geocoder completion: ", results);
                  searchLocations(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                } else {
                  console.log("didn't make it to geocoder completion: ", google.maps.GeocoderStatus);
                }
              });
            } else if (jQuery(".related-physicians .submit-button").attr("data-lat") !== undefined) {
              searchLocations(parseFloat(jQuery(".related-physicians .submit-button").attr("data-lat")), parseFloat(jQuery(".related-physicians .submit-button").attr("data-lon")));
            }
          });
        }
      }
    };
    var searchLocations = function(lat1, lon1) {
      var locdis = [];
      const filterMiles = parseInt(jQuery(".narrow-offices #miles-from").val());
      vars.misc.rpMap.map.bounds = new google.maps.LatLngBounds;
      const itemLatLon = new google.maps.LatLng(lat1, lon1);
      const deg2rad = function(deg) {
        return deg * (Math.PI / 180);
      };
      vars.misc.rpMap.map.bounds.extend(itemLatLon);
      jQuery(".narrow-offices .submit-button").attr("data-lat", lat1);
      jQuery(".narrow-offices .submit-button").attr("data-lon", lon1);
      jQuery('.control-wrapper[data-control="office"] .option').each(function(index) {
        var lat2 = jQuery(this).attr("data-lat");
        var lon2 = jQuery(this).attr("data-lon");
        if (lat2 === "" || lon2 === "" || jQuery(this).attr("data-value") === "")
          return;
        var R = 3963.1676;
        var dLat = deg2rad(lat2 - lat1);
        var dLon = deg2rad(lon2 - lon1);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        jQuery(this).attr("data-distance", d);
        jQuery(this).find(".distance").html(" (" + d.toFixed(1) + " miles)").removeClass("hidden");
        if (d > parseFloat(filterMiles)) {
          jQuery(this).hide();
          vars.misc.rpMap.markers[jQuery(this).attr("data-value")].setVisible(false);
        } else {
          if (jQuery('.control-wrapper[data-control="office"] .control-list').hasClass(jQuery(this).attr("data-type"))) {
            jQuery(this).show();
            var itemLatLon2 = new google.maps.LatLng(lat2, lon2);
            vars.misc.rpMap.map.bounds.extend(itemLatLon2);
            vars.misc.rpMap.markers[jQuery(this).attr("data-value")].setVisible(true);
          }
        }
      });
      var list = jQuery('.control-wrapper[data-control="office"] .control-list');
      var items = list.children("li");
      items.sort(function(a, b) {
        return jQuery(a).data("distance") - jQuery(b).data("distance");
      });
      list.append(items);
      vars.misc.rpMap.map.fitBounds(vars.misc.rpMap.map.bounds);
      vars.misc.rpMap.map.panToBounds(vars.misc.rpMap.map.bounds);
    };
    var locationsDirections = function() {
      if (jQuery(".single-locations").length) {
        jQuery(".custom-direction button").click(function() {
          var buttonClicked = jQuery(this);
          var searchInput = buttonClicked.siblings("#searchTextField");
          var method = buttonClicked.siblings("fieldset").find('input:radio[name="t-method"]:checked').val();
          if (searchInput.val() != "") {
            var url = "http://maps.google.com/maps?saddr=" + searchInput.val().replace(/\s/g, "+") + "&daddr=Rothman Orthopaedics,+" + searchInput.attr("data-address") + "&dirflg=" + method;
            lqx.analytics.sendGAEvent({
              eventCategory: "Outbound Links",
              eventAction: "click",
              eventLabel: url,
              nonInteraction: true
            });
            if (jQuery("body.ios").length) {
              window.location.assign(url);
            } else {
              window.open(url);
            }
          }
        });
        jQuery(".manual-container .manual-link").click(function() {
          var searchQueryEl = jQuery(".custom-direction #searchTextField");
          navigator.geolocation.getCurrentPosition(function(loc) {
            lqx.log("navigator.done ", loc.coords.latitude, loc.coords.longitude);
            searchQueryEl.attr("data-lat", loc.coords.latitude);
            searchQueryEl.attr("data-lon", loc.coords.longitude);
            searchQueryEl.val("Current Location");
            var button = jQuery(".custom-direction button");
            var method = button.siblings("fieldset").find('input:radio[name="t-method"]:checked').val();
            var lat = jQuery(searchQueryEl).attr("data-lat");
            var lon = jQuery(searchQueryEl).attr("data-lon");
            var url = "http://maps.google.com/maps?saddr=" + lat + "," + lon + "&daddr=Rothman Orthopaedics,+" + searchQueryEl.attr("data-address") + "&dirflg=" + method;
            lqx.analytics.sendGAEvent({
              eventCategory: "Outbound Links",
              eventAction: "click",
              eventLabel: url,
              nonInteraction: true
            });
            if (jQuery("body.ios").length) {
              window.location.assign(url);
            } else {
              window.open(url);
            }
          });
          var pos = {
            lat: jQuery(searchQueryEl).attr("data-lat"),
            lon: jQuery(searchQueryEl).attr("data-lon")
          };
        });
        jQuery(".custom-direction #searchTextField").keyup(function() {
          var button = jQuery(this).siblings("button.go");
          if (jQuery(this).val() == "")
            button.addClass("disabled");
          else
            button.removeClass("disabled");
        });
        jQuery(".custom-direction label").click(function() {
          var clickedLabel = jQuery(this);
          var allLabel = jQuery(this).parent().find("label");
          allLabel.not(clickedLabel).removeClass("active");
          allLabel.not(clickedLabel).find("input[type=radio]").attr("checked", false);
          clickedLabel.addClass("active");
          clickedLabel.find("input[type=radio]").attr("checked", true);
        });
        jQuery(".custom-direction #searchTextField").on("keypress", function(e) {
          if (e.which == 13) {
            var button = jQuery(".custom-direction button");
            var searchInput = jQuery("#searchTextField");
            var method = button.siblings("fieldset").find('input:radio[name="t-method"]:checked').val();
            if (searchInput.val() != "") {
              var url = "http://maps.google.com/maps?saddr=" + searchInput.val().replace(/\s/g, "+") + "&daddr=Rothman Orthopaedics,+" + searchInput.attr("data-address") + "&dirflg=" + method;
              lqx.analytics.sendGAEvent({
                eventCategory: "Outbound Links",
                eventAction: "click",
                eventLabel: url,
                nonInteraction: true
              });
              if (jQuery("body.ios").length) {
                window.location.assign(url);
              } else {
                window.open(url);
              }
            }
          }
        });
      }
    };
    var servicesLocations = function() {
      var $manual = jQuery(".single-services .manual-container");
      if (!$manual.length) {
        return;
      }
    };
    const yourVisitTabNavigation = function() {
      if (jQuery(".lqx-block-tabs.your-visit").length) {
        jQuery(window).on("load", function() {
          let hash = window.location.hash;
          if (hash.length > 1) {
            console.log("got to switch: ", hash.substr(1));
            switch (hash.substr(1)) {
              case "before-your-visit":
                jQuery(".lqx-block-tabs.your-visit .tabs-list li:nth-of-type(1) button").trigger("click");
                break;
              case "for-your-visit":
                jQuery(".lqx-block-tabs.your-visit .tabs-list li:nth-of-type(2) button").trigger("click");
                break;
              case "after-your-visit":
                jQuery(".lqx-block-tabs.your-visit .tabs-list li:nth-of-type(3) button").trigger("click");
                break;
              default:
                break;
            }
          }
        });
        jQuery(".wp-block-button.your-visit").click(function() {
          jQuery(".lqx-block-tabs.your-visit .tabs-list li:nth-of-type(2) button").trigger("click");
        });
        jQuery(".wp-block-button.after-your-visit").click(function() {
          jQuery(".lqx-block-tabs.your-visit .tabs-list li:nth-of-type(3) button").trigger("click");
        });
      }
    };
    const patientResourcesSearchInit = function() {
      if (jQuery(".page-for-patients-visitors").length) {
        vars.misc.prLunrDocsText = [];
        vars.misc.prResultList = [];
        const items = JSON.parse(jQuery(".content.grid-container").attr("data-items"));
        console.log(items);
        let i = 0;
        items.forEach(function(item) {
          console.log(item);
          var title = item["title"];
          var text = item["body"];
          var group = item["group"];
          vars.misc.prLunrDocsText.push({
            id: i,
            text,
            title
          });
          vars.misc.prResultList.push({
            id: i,
            text,
            title,
            group
          });
          i++;
        });
        vars.misc.prLunrIdxText = lunr(function() {
          this.ref("id");
          this.field("text");
          this.field("title");
          vars.misc.prLunrDocsText.forEach(function(doc) {
            this.add(doc);
          }, this);
        });
        console.log("lunr initialization results:", vars.misc.prLunrIdxText, vars.misc.prLunrIdxText);
        jQuery("#your-visit-search-input").keyup(function(e) {
          if (jQuery("body").attr("screen") !== "xs") {
            if (e.keyCode !== 13) {
              vars.misc.searchBox.query = jQuery(this).val();
              patientResourcesSearch(vars.misc.searchBox.query);
            }
          }
        });
        jQuery(".side-search button").click(function() {
          vars.misc.searchBox.query = jQuery("#your-visit-search-input").val();
          patientResourcesSearch(vars.misc.searchBox.query);
        });
        jQuery(".side-search .mobile-close").click(function() {
          jQuery(".side-search").removeClass("active-search");
        });
      }
    };
    const patientResourcesSearch = function(query) {
      var freeTextResults = [];
      var html = "<ul>";
      var lightboxHtml = "";
      query = query.replace(/[^\w\s]/gi, "");
      jQuery(".side-search").addClass("active-search");
      jQuery("#your-visit-search-results ul, #your-visit-search-results .no-results").detach();
      var search_results_text = vars.misc.prLunrIdxText.search(query);
      search_results_text.forEach(function(i) {
        var x = parseInt(i.ref);
        var target = vars.misc.prResultList.findIndex(function(e) {
          return e.id == x;
        });
        freeTextResults.push(target);
      });
      if (freeTextResults.length > 0) {
        freeTextResults.forEach(function(index) {
          console.log(vars.misc.prResultList[index]);
          html += "<li>";
          html += "<h4>" + vars.misc.prResultList[index].title + "</h4>";
          html += "<p>" + vars.misc.prResultList[index].text.substr(0, 100) + "...</p>";
          var raw = vars.misc.prResultList[index].group.split("-");
          var groupHash = "";
          var groupString = "";
          var i = 0;
          switch (vars.misc.prResultList[index].group) {
            case "Before Your Visit":
              groupHash = "before-your-visit";
              break;
            case "For Your Visit":
              groupHash = "for-your-visit";
              break;
            case "After Your Visit":
              groupHash = "after-your-visit";
              break;
            default:
              break;
          }
          lightboxHtml += '<h4><a href="/for-patient-visitors/your-visit/">' + vars.misc.prResultList[index].group + "</a></h4>";
          lightboxHtml += "<h1>" + vars.misc.prResultList[index].title + "</h1>";
          lightboxHtml += "<div>" + vars.misc.prResultList[index].text + "</div>";
          const lyqboxObject = {
            name: "pr-search",
            slug: index.toString(),
            type: "html",
            html: encodeURI(lightboxHtml)
          };
          html += '<span class="open-lightbox" data-lyqbox=' + JSON.stringify(lyqboxObject) + ">View More</span>";
          html += "</li>";
        });
        html += "</ul>";
      } else {
        html = '<div class="no-results"><span>No Results</span></div>';
      }
      jQuery(html).appendTo("#your-visit-search-results");
    };
    const prSearchScroll = function() {
      if (jQuery(".page-for-patients-visitors").length) {
        var breakpoint = jQuery(".main-content").offset().top;
        var scroll = jQuery(window).scrollTop();
        var bottom = jQuery("footer").offset().top - 900;
        console.log("breakpoint and scroll", breakpoint, scroll, bottom);
        if (scroll >= bottom) {
          jQuery(".side-search").removeClass("search-fixed");
        } else if (scroll >= breakpoint) {
          jQuery(".side-search").addClass("search-fixed");
        } else {
          jQuery(".side-search").removeClass("search-fixed");
        }
      }
    };
    var bioLightbox = function() {
      lqx.vars.document.on("click", '.lqx-block-cards[data-preset="personnel-cards"] .js-open-bio-modal', function(e) {
        e.preventDefault();
      });
      lqx.vars.document.on("click", "dialog.lyqbox[open]", function(e) {
        var $dialog = jQuery(this);
        if (!jQuery(e.target).closest(".wrapper.active").length) {
          $dialog.find("button.close").trigger("click");
        }
      });
    };
    var servicesMapSmall = function() {
      var $filters = jQuery('.lqx-block-filters[data-preset="service-related-locations"]');
      var $locations = jQuery(".cat-locations");
      var $drawer = jQuery("#quick-access-drawer");
      $filters.on("click", ".view-control div", function() {
        var $btn = jQuery(this);
        if ($btn.hasClass("active"))
          return;
        $filters.find(".view-control .active").removeClass("active");
        $btn.addClass("active");
        var isMap = $btn.hasClass("map");
        $locations.toggleClass("map-active", isMap).toggleClass("items-active", !isMap);
      });
      $filters.on("click", ".filter-control", function() {
        $filters.addClass("filters-active");
        $drawer.hide();
      });
      $filters.on("click", ".filter-close, .sm-confirm", function() {
        $filters.removeClass("filters-active");
        $drawer.show();
      });
    };
    const appointmentOOR = function() {
      if (jQuery(".page-appointments").length) {
        jQuery("#select-your-region").click(function() {
          jQuery("header .regions .selection").addClass("open");
        });
      }
    };
    const appointmentNoShow = function() {
      if (jQuery(".no-show-policy.expand-no-show").length) {
        jQuery(".no-show-policy.expand-no-show h2").click(function() {
          console.log("detected click");
          jQuery(".no-show-policy").toggleClass("open");
        });
      }
    };
    var specialtiesNavTabs = function() {
      if (!jQuery(".specialties-nav").length)
        return;
      if (!jQuery(".tabs .tabs-list .tab").length) {
        jQuery(".specialties-nav li").addClass("hidden");
        return;
      }
      var tabExists = function(label) {
        var found = false;
        jQuery(".tabs .tabs-list .tab").each(function() {
          if (jQuery.trim(jQuery(this).text()) === label) {
            found = true;
            return false;
          }
        });
        return found;
      };
      jQuery(".specialties-nav li").each(function() {
        var label = jQuery.trim(jQuery(this).text());
        if (!tabExists(label)) {
          jQuery(this).addClass("no-show");
        }
      });
      jQuery(".specialties-nav a").on("click", function(e) {
        e.preventDefault();
        var label = jQuery.trim(jQuery(this).text());
        jQuery(".tabs .tabs-list .tab").each(function() {
          if (jQuery.trim(jQuery(this).text()) === label) {
            jQuery(this).trigger("click");
            jQuery("html, body").animate({
              scrollTop: jQuery(".tabs").offset().top - (window.outerWidth > 720 ? 186 : 100)
            }, 400);
            return false;
          }
        });
      });
    };
    const applyRegionBounds = function(lqxMap, region) {
      if (!lqxMap || !lqxMap.map || !lqxMap.items)
        return;
      try {
        const divId = lqxMap.map.getDiv().id;
        if (divId === "locations-category")
          return;
      } catch (e) {
      }
      if (!region || region === "outside-region" || region === "everywhere") {
        const allBounds = new google.maps.LatLngBounds;
        lqxMap.items.forEach(function(item) {
          allBounds.extend(new google.maps.LatLng(item.lat, item.lon));
        });
        if (!allBounds.isEmpty()) {
          lqxMap.map.fitBounds(allBounds);
          lqxMap.map.panToBounds(allBounds);
          google.maps.event.addListenerOnce(lqxMap.map, "idle", function() {
            lqxMap.map.fitBounds(allBounds);
          });
        }
        return;
      }
      const bounds = new google.maps.LatLngBounds;
      let matchCount = 0;
      lqxMap.items.forEach(function(item) {
        if (Array.isArray(item.regions) && item.regions.indexOf(region) !== -1) {
          bounds.extend(new google.maps.LatLng(item.lat, item.lon));
          matchCount++;
        }
      });
      if (matchCount === 0) {
        const allBounds = new google.maps.LatLngBounds;
        lqxMap.items.forEach(function(item) {
          allBounds.extend(new google.maps.LatLng(item.lat, item.lon));
        });
        if (!allBounds.isEmpty()) {
          lqxMap.map.fitBounds(allBounds);
          lqxMap.map.panToBounds(allBounds);
          google.maps.event.addListenerOnce(lqxMap.map, "idle", function() {
            lqxMap.map.fitBounds(allBounds);
          });
        }
        return;
      }
      lqxMap.map.fitBounds(bounds);
      lqxMap.map.panToBounds(bounds);
      google.maps.event.addListenerOnce(lqxMap.map, "idle", function() {
        lqxMap.map.fitBounds(bounds);
      });
    };
    const mapRegionFocus = function() {
      jQuery(document).ready(function() {
        setTimeout(function() {
          const region = jQuery("body").attr("data-region");
          if (lqx.vars.map && lqx.vars.map.maps) {
            lqx.vars.map.maps.forEach(function(lqxMap) {
              applyRegionBounds(lqxMap, region);
            });
          }
        }, 500);
      });
    };
    const sizeListControls = function() {
      jQuery('.lqx-block-filters.related-physicians .control-wrapper[data-control-type="field"]').each(function() {
        const wrapper = jQuery(this);
        const textEl = wrapper.find("label .selected, label .label").first();
        if (!textEl.length)
          return;
        const measurer = jQuery("<span>").css({
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          visibility: "hidden",
          whiteSpace: "nowrap",
          fontFamily: textEl.css("fontFamily"),
          fontSize: textEl.css("fontSize"),
          fontWeight: textEl.css("fontWeight"),
          letterSpacing: textEl.css("letterSpacing")
        }).text(textEl.text().trim()).appendTo("body");
        const textWidth = measurer.outerWidth();
        measurer.remove();
        wrapper.css("width", textWidth + 34 + "px");
      });
    };
    const nyRegionAlert = function() {
      const showAlert = function() {
        if (sessionStorage.getItem("ny-alert-dismissed"))
          return;
        const subdivision = jQuery("body").attr("subdivision") || lqx.vars.geolocate && lqx.vars.geolocate.location && lqx.vars.geolocate.location.subdivision;
        if (subdivision !== "NY" && subdivision !== "New York")
          return;
        const alertsContainer = jQuery("#lqx-module-alerts");
        if (!alertsContainer.length || alertsContainer.find(".ny-region-alert").length)
          return;
        const alertHtml = '<div class="alert text-navy-blue-100 ny-region-alert font-semibold py-[1rem] px-[2.5rem] flex items-center" style="background-color:#FEEEDD;">' + "Looking for Rothman Orthopaedics in Greater New York? " + '<a class="text-navy-blue-100 font-normal hover:text-navy-blue-100 ml-4" href="https://rothmanny.com" target="_blank">Go to RothmanNY.com</a>' + '<button class="ny-alert-dismiss" aria-label="Dismiss" style="right: 3rem;margin:0;background:none;border:none;cursor:pointer;font-size:28px;line-height:1;position: absolute;padding:0">&times;</button>' + "</div>";
        const $alert = jQuery(alertHtml);
        $alert.find(".ny-alert-dismiss").on("click", function() {
          $alert.remove();
          sessionStorage.setItem("ny-alert-dismissed", "1");
        });
        alertsContainer.prepend($alert);
      };
      if (lqx.geolocate && typeof lqx.geolocate.ready === "function") {
        lqx.geolocate.ready(showAlert);
      } else {
        lqx.vars.document.on("geolocateready", showAlert);
      }
    };
    return {
      init,
      relatedPhysicians,
      sizeListControls
    };
  })();

  // js/custom/scripts/search.ts
  var search = (() => {
    const init = (customCfg) => {
      if (vars.search?.init)
        return;
      vars.search = {
        init: false,
        searchBox: {
          searchLimit: 3,
          searchThrottle: false,
          searchThrottleCap: false,
          keyNotValidArray: [
            9,
            27,
            35,
            36,
            37,
            38,
            39,
            40,
            45,
            16,
            17,
            18,
            19,
            20,
            33,
            34,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            144
          ],
          query: "",
          suggestion: "",
          suggestionQueue: [],
          cache: {
            suggestions: {},
            results: {}
          },
          xhrObjects: {
            phy: [],
            spe: [],
            loc: [],
            con: []
          },
          nyFlag: false,
          isNYUser: false
        }
      };
      cfg.search = {
        enabled: true,
        throttleDuration: 160,
        minWeight: 1
      };
      if (customCfg)
        cfg.search = jQuery.extend(true, cfg.search, customCfg);
      if (cfg.search.enabled) {
        lqx.log("Initializing search");
        jQuery(function($) {
          $(".search-icon").on("click", function() {
            $("header").toggleClass("search-open");
            $("header").removeClass("mobile-menu-open");
          });
          $("#menu-toggle").on("click", function() {
            $("header").removeClass("search-open");
          });
          jQuery(".aa-Form .aa-ClearButton").on("click", function(e) {
            e.preventDefault();
            var query = jQuery(".aa-Form .aa-Input").val();
            if (query && query.length > 0) {
              window.location.href = "/?s=" + encodeURIComponent(query);
            }
          });
          jQuery(document).on("click", ".search-open .icon-x-white", function() {
            if (swtAutocompleteInstance.cm_autocomplete_1) {
              swtAutocompleteInstance.cm_autocomplete_1.setQuery("");
              swtAutocompleteInstance.cm_autocomplete_1.refresh();
              jQuery('.aa-InputWrapper input[type="search"]').trigger("focus");
            }
            jQuery("header.search-open").removeClass("search-open");
          });
          jQuery(document).on("click", ".search-open .search-all", function() {
            jQuery(".aa-ClearButton").trigger("click");
          });
          jQuery(document).on("input keyup", '.aa-InputWrapper input[type="search"]', function() {
            var currentQuery = jQuery(this).val();
            jQuery(".query-text").text(currentQuery);
          });
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && node.classList.contains("aa-PanelLayout")) {
                  setTimeout(() => {
                    const currentQuery = jQuery('.aa-InputWrapper input[type="search"]').val();
                    if (!node.querySelector(".autocomplete-empty")) {
                      const template = document.getElementById("tmpl-cm-autocomplete-no-results");
                      if (template) {
                        let templateContent = template.innerHTML;
                        templateContent = templateContent.replace("{{ data.query }}", currentQuery);
                        node.insertAdjacentHTML("beforeend", templateContent);
                      }
                    }
                  }, 150);
                }
              });
            });
          });
          observer.observe(document.body, { childList: true, subtree: true });
          if (jQuery(".search-results-page").length) {
            jQuery(".collection-switcher-wrapper .toggle-button").on("click", function() {
              jQuery(".collection-switcher-wrapper").toggleClass("open");
            });
            jQuery(document).on("click", ".cmswt-IndexSwitcher-item", function() {
              var label = jQuery(this).find("a").text().trim();
              if (label === "All") {
                label = "Select Type";
              }
              jQuery(".collection-switcher-wrapper .toggle-button").text(label);
              jQuery(".collection-switcher-wrapper").removeClass("open");
            });
            jQuery("#clear-search").on("click", function() {
              const el = document.querySelector(".cmswt-IndexSwitcher-item:first-of-type a");
              if (el)
                el.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
              jQuery(".toggle-button").text("Select Type");
            });
            setupAllCollectionSearch();
          }
        });
      }
      vars.search.init = true;
    };
    function setupAllCollectionSearch() {
      const container = document.querySelector(".cmswt-InstantSearch");
      if (!container)
        return;
      const settings = typeof cm_typesense_instant_search_default_settings !== "undefined" ? cm_typesense_instant_search_default_settings : null;
      if (!settings)
        return;
      const config = JSON.parse(container.dataset.config || "{}");
      const collections = config.collections || [];
      const queryBy = container.dataset.query_by || "post_title,post_content";
      const instanceId = container.dataset.id || "";
      let isAllMode = true;
      let currentQuery = container.getAttribute("data-search_query") || "";
      let searchTimeout;
      const allHitsDiv = document.createElement("div");
      allHitsDiv.className = "cmswt-Result-hits cmswt-Result-hits_all ais-Hits";
      const allResultsWrap = document.createElement("div");
      allResultsWrap.className = "cmswt-Result cmswt-Result-all";
      allResultsWrap.appendChild(allHitsDiv);
      const searchBoxContainer = container.querySelector(".cmswt-SearchBox");
      if (searchBoxContainer && !searchBoxContainer.querySelector("input")) {
        const placeholder = container.dataset.placeholder || "Search…";
        searchBoxContainer.innerHTML = `
        <div class="ais-SearchBox">
          <form class="ais-SearchBox-form" novalidate>
            <input class="ais-SearchBox-input" autocomplete="off" autocorrect="off"
                   autocapitalize="off" spellcheck="false" maxlength="512"
                   type="search" placeholder="${placeholder}"
                   value="${currentQuery.replace(/"/g, "&quot;")}">
          </form>
        </div>`;
      }
      const injectFakePf = () => {
        const swt = window.swtInstance;
        if (swt && instanceId && !swt[instanceId]) {
          swt[instanceId] = {
            helper: { state: { query: currentQuery } },
            dispose: () => {
            },
            __infiniteObserver: null
          };
        }
      };
      setTimeout(injectFakePf, 0);
      container.addEventListener("input", (e) => {
        const target = e.target;
        if (!target.matches(".ais-SearchBox-input"))
          return;
        if (!isAllMode)
          return;
        currentQuery = target.value;
        const swt = window.swtInstance;
        if (swt?.[instanceId]?.helper?.state)
          swt[instanceId].helper.state.query = currentQuery;
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => performAllSearch(currentQuery), 300);
      });
      const switcher = container.querySelector(".cmswt-IndexSwitcher");
      if (switcher) {
        switcher.addEventListener("click", (e) => {
          const link = e.target.closest("a[data-collection]");
          if (!link)
            return;
          if (link.getAttribute("data-collection") === "all") {
            e.stopPropagation();
            e.preventDefault();
            isAllMode = true;
            const searchInput = container.querySelector(".ais-SearchBox-input");
            currentQuery = searchInput?.value || "";
            activateAllMode();
          } else {
            isAllMode = false;
            deactivateAllMode();
          }
        }, true);
      }
      activateAllMode();
      function activateAllMode() {
        const resultsArea = container.querySelector(".cmswt-Results");
        if (resultsArea && !container.querySelector(".cmswt-Result-all")) {
          resultsArea.appendChild(allResultsWrap);
        }
        allResultsWrap.style.display = "";
        container.querySelectorAll(".cmswt-Result:not(.cmswt-Result-all)").forEach((el) => {
          el.style.display = "none";
        });
        container.querySelectorAll(".cmswt-IndexSwitcher-item").forEach((li) => li.classList.remove("active"));
        const allLink = container.querySelector('a[data-collection="all"]');
        allLink?.closest(".cmswt-IndexSwitcher-item")?.classList.add("active");
        const label = container.querySelector(".cmswt-CollectionMenu-currentLabel");
        if (label)
          label.textContent = "All";
        performAllSearch(currentQuery);
      }
      function deactivateAllMode() {
        allResultsWrap.style.display = "none";
        container.querySelectorAll(".cmswt-Result:not(.cmswt-Result-all)").forEach((el) => {
          el.style.display = "";
        });
      }
      async function performAllSearch(query) {
        const protocol = (settings.protocol || "https").replace(/[:/]+$/, "");
        const node = (settings.node || "").replace(/^[:/]+/, "");
        const url = `${protocol}://${node}:${settings.port}/multi_search`;
        allHitsDiv.innerHTML = '<div class="cmswt-searching">Searching&hellip;</div>';
        try {
          const res = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-TYPESENSE-API-KEY": settings.search_api_key
            },
            body: JSON.stringify({
              searches: collections.map((col) => ({
                collection: col,
                q: query || "*",
                query_by: queryBy,
                query_by_weights: queryBy.split(",").map((f) => f.trim() === "post_title" ? 10 : 1).join(","),
                prioritize_exact_match: true,
                per_page: 10
              }))
            })
          });
          const data = await res.json();
          const hits = (data.results || []).flatMap((r) => r.hits || []).sort((a, b) => (b.text_match ?? 0) - (a.text_match ?? 0));
          renderHits(hits);
        } catch (_err) {
          allHitsDiv.innerHTML = '<div class="cmswt-error">Search unavailable.</div>';
        }
      }
      function renderHits(hits) {
        if (!hits.length) {
          allHitsDiv.innerHTML = '<p class="cmswt-NoResults">No results found.</p>';
          return;
        }
        allHitsDiv.innerHTML = hits.map((hit) => {
          const doc = hit.document || {};
          const hl = hit.highlight || {};
          const title = hl.post_title?.snippet || doc.post_title || "";
          const excerpt = doc.post_content ? doc.post_content.substring(0, 220) + "…" : "";
          const thumbnail = doc.post_thumbnail_html || "";
          const permalink = doc.permalink || "#";
          return `<div class="ais-Hits-item">
          <div class="hit-content flex gap-[2rem]">
            <a href="${permalink}" class="result-thumb">${thumbnail}</a>
            <div class="flex flex-col">
              <a href="${permalink}" class="no-underline">
                <h3 class="title">${title}</h3>
              </a>
              <div class="excerpt"><p>${excerpt}</p></div>
              <div class="hit-link underline hover:no-underline">
                <a href="${permalink}" class="ais-hits--title-link">Visit Page</a>
              </div>
            </div>
          </div>
        </div>`;
        }).join("");
      }
    }
    return {
      init
    };
  })();

  // js/custom/scripts/events.ts
  var events = (() => {
    const init = (customCfg) => {
      if (vars.events?.init)
        return;
      vars.events = {
        init: false
      };
      cfg.events = {
        enabled: true
      };
      if (customCfg)
        cfg.events = jQuery.extend(true, cfg.events, customCfg);
      if (cfg.events.enabled) {
        lqx.log("Initializing events");
        if (jQuery(".page-tribe_events_cat, .post-type-archive-tribe_events, .tmpl-archive-tribe_events").length || jQuery('.lqx-block-filters[data-preset="events"]').length) {
          groupByMonth();
          jQuery(document).on("ajaxComplete", function() {
            groupByMonth();
          });
        }
        jQuery(document).ready(function($) {
          var showingLocal = false;
          $(".timezone-toggle").on("click", function(e) {
            e.preventDefault();
            var $this = $(this);
            var $dateItem = $(".event-date-item");
            var $dateValue = $(".date-value");
            var $timeRange = $(".time-range");
            var $timezoneName = $(".timezone-name");
            var startISO = $dateItem.data("start");
            var endISO = $dateItem.data("end");
            var eventTz = $dateItem.data("event-tz");
            var eventTzCity = $dateItem.data("event-tz-city");
            var startDate = new Date(startISO);
            var endDate = new Date(endISO);
            if (!showingLocal) {
              var localStart = formatTime(startDate);
              var localEnd = formatTime(endDate);
              var localDateStr = startDate.toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric"
              });
              $dateValue.text(localDateStr);
              $timeRange.text(localStart !== localEnd ? localStart + " - " + localEnd : localStart);
              var userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
              var userTzCity = getTzCity(userTz);
              var tzAbbr = startDate.toLocaleTimeString("en-US", {
                timeZoneName: "short"
              }).split(" ").pop();
              var tzOffset = formatTimezoneOffset(startDate);
              $timezoneName.text(userTzCity + " Time " + tzAbbr + " (" + tzOffset + ")");
              $this.text("Show Event Time Zone");
              showingLocal = true;
            } else {
              var eventStart = formatTimeInTimezone(startDate, eventTz);
              var eventEnd = formatTimeInTimezone(endDate, eventTz);
              var eventDateStr = startDate.toLocaleDateString("en-US", {
                timeZone: eventTz,
                month: "short",
                day: "numeric",
                year: "numeric"
              });
              $dateValue.text(eventDateStr);
              $timeRange.text(eventStart !== eventEnd ? eventStart + " - " + eventEnd : eventStart);
              var eventTzAbbr = getTimezoneAbbr(startDate, eventTz);
              var eventTzOffset = getTimezoneOffset(startDate, eventTz);
              $timezoneName.text(eventTzCity + " Time " + eventTzAbbr + " (" + eventTzOffset + ")");
              $this.text("Show Your Time Zone");
              showingLocal = false;
            }
          });
          function getTzCity(timezone) {
            var parts = timezone.split("/");
            var city = parts[parts.length - 1];
            return city.replace(/_/g, " ");
          }
          function formatTime(date) {
            return date.toLocaleString("en-US", {
              hour: "numeric",
              minute: "2-digit",
              hour12: true
            });
          }
          function formatTimeInTimezone(date, timezone) {
            return date.toLocaleString("en-US", {
              timeZone: timezone,
              hour: "numeric",
              minute: "2-digit",
              hour12: true
            });
          }
          function formatTimezoneOffset(date) {
            var offset = -date.getTimezoneOffset();
            var hours = Math.floor(Math.abs(offset) / 60);
            var minutes = Math.abs(offset) % 60;
            var sign = offset >= 0 ? "+" : "-";
            return sign + padZero(hours) + ":" + padZero(minutes);
          }
          function getTimezoneAbbr(date, timezone) {
            var formatted = date.toLocaleString("en-US", {
              timeZone: timezone,
              timeZoneName: "short"
            });
            return formatted.split(" ").pop();
          }
          function getTimezoneOffset(date, timezone) {
            try {
              var formatter = new Intl.DateTimeFormat("en-US", {
                timeZone: timezone,
                timeZoneName: "longOffset"
              });
              var parts = formatter.formatToParts(date);
              var offsetPart = parts.find(function(p) {
                return p.type === "timeZoneName";
              });
              return offsetPart ? offsetPart.value : "";
            } catch (e) {
              return "";
            }
          }
          function padZero(num) {
            return num < 10 ? "0" + num : num.toString();
          }
        });
      }
      vars.events.init = true;
    };
    const groupByMonth = () => {
      const container = jQuery('.lqx-block-filters[data-preset="events"] .posts, .lqx-block-filters[data-preset="events"] ul.cards');
      if (!container.length)
        return;
      container.find("h3.month-group-heading").remove();
      let lastMonth = "";
      container.find("li.card[data-event-month]").each(function() {
        const month = jQuery(this).attr("data-event-month");
        const label = jQuery(this).attr("data-event-month-label");
        if (month !== lastMonth) {
          jQuery(this).before('<h3 class="month-group-heading">' + label + "</h3>");
          lastMonth = month;
        }
      });
    };
    return {
      init,
      groupByMonth
    };
  })();

  // js/scripts.ts
  var init = (customCfg) => {
    if (vars.init)
      return;
    if (typeof customCfg !== "object")
      customCfg = {};
    const mods = [
      "regions",
      "locations",
      "infographic",
      "physicians",
      "treatments_conditions",
      "misc",
      "search",
      "events"
    ];
    console.log("Initializing scripts");
    lqx.log("Custom configuration", customCfg);
    mods.forEach((mod) => {
      $lqx[mod].init(mod in customCfg ? customCfg[mod] : {});
    });
    lqx.vars.document.trigger("$lqxready");
    lqx.log("$lqxready Event");
    vars.init = true;
  };
  var ready = (callback) => {
    if (vars.init === true) {
      callback();
    } else {
      vars.document.on("$lqxready", callback);
    }
  };
  var expObj = Object.defineProperties({
    init,
    ready,
    regions,
    locations,
    infographic,
    physicians,
    treatments_conditions,
    misc,
    search,
    events
  }, {
    cfg: {
      get() {
        return cfg;
      },
      set() {
        return;
      }
    },
    vars: {
      get() {
        return vars;
      },
      set() {
        return;
      }
    }
  });
  var scripts_default = expObj;
  if (typeof window !== "undefined") {
    window.$lqx = expObj;
  }
})();
